export const prepareAoInsuranceCardData = (companyList, travelProductType) => {
  let data = [];
  if (companyList && companyList.length) {
    companyList.forEach((company) => {
      let travel_product_type =
        travelProductType && travelProductType.length
          ? travelProductType[0]?.options
          : [];

      let plans = company?.extracted_data?.eligiblePlans || [];
      if (plans && plans.length) {
        plans.forEach((plan, index) => {
          let covers =
            plan?.covers && plan?.covers.length
              ? plan?.covers.map((cover, index) => ({
                  ...cover,
                  isSelected: index === 0 ? true : false,
                }))
              : [];

          data.push({
            object_id: index,
            company_name: company?.insurance_company?.company_title,
            company_name_ar: company?.insurance_company?.company_title_ar,
            company_description_en:
              company?.insurance_company?.company_descriptions_en,
            company_description_ar:
              company?.insurance_company?.company_descriptions_ar,
            company_faq_en: company?.insurance_company?.faq_en,
            company_faq_ar: company?.insurance_company?.faq_ar,
            company_id: company?.insurance_company?.id,
            company_image: company?.insurance_company?.image,
            plan_code: plan?.prodCode,
            plan_name: plan?.ProdName,
            plan_name_ar: plan?.ProdNameAr,
            base_price:
              plan?.covers && plan?.covers?.length
                ? plan?.covers[0]?.premium
                : 0,
            premium_value:
              plan?.covers && plan?.covers?.length
                ? plan?.covers[0]?.premium
                : 0,
            premium_currency: "OMR",
            covers: covers,
            extracted_data: company?.extracted_data || {},
            insurance_company_product_mapping_id: company?.id,
            area_of_coverage:
              travel_product_type.find(
                (tp) => tp.company == company?.insurance_company?.id
              ) || null,
          });
        });
      }
    });
  }

  return data;
};
